import actions from './actions';
import { exportCommonFile } from "../../../../helpers/utilities";

const initState = {
    loader: true,
    error: '',
    purchaseInvoiceDetails: [],
    purchaseTransactionDetails: []
};

export default function purchaseTransactionsReducer(state = initState, action) {
    switch (action.type) {
        case actions.PURCHASE_INVOICE_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.PURCHASE_INVOICE_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                purchaseInvoiceDetails: action.payload,
            };
        }
        case actions.PURCHASE_INVOICE_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }
        case actions.PURCHASE_TRANSACTION_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.PURCHASE_TRANSACTION_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                purchaseTransactionDetails: action.payload,
            };
        }
        case actions.PURCHASE_TRANSACTION_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }
        case actions.CLEAR_PURCHASE_TRANSACTION_DETAILS_START: {
            return {
                ...state,
            };
        }
        case actions.CLEAR_PURCHASE_TRANSACTION_DETAILS_SUCCESS: {
            return initState;
        }
        default:
            return state;
    }
}